/**
 Безопасная обертка над LocalStorage
 workaround для iframe
 */

function onError(error) {
  console.debug('localStorage access error:', error)
}

export function safeGetItem(key) {
  try {
    return localStorage.getItem(key)
  } catch (error) {
    return null
  }
}

export function safeSetItem(key, value) {
  try {
    return localStorage.setItem(key, value)
  } catch (error) {
    onError(error)
  }
}

export function safeGetJson(key, defaultValue = null) {
  try {
    return JSON.parse(safeGetItem(key)) || defaultValue
  } catch (error) {
    return defaultValue
  }
}
